import { connect } from "react-redux"
import { compose } from "redux"
import MastersSummary from "./MastersSummary"
import { getMasterAlarmModesList, getMasterFlagModesList } from "constants/statusBits"
import { overlays } from "constants/overlays"
import { getMasterLocIds } from "utils/url"
import { withRouter } from "react-router-dom"

export const getDeviceType = (state, mLocId) => {
	return (state.masterDetails[mLocId] || {}).deviceType
}

export const getUrlTimestamp = (urlSearch = "") => {
	const params = new URLSearchParams(urlSearch)
	return parseInt(params.get("ts"), 10) || undefined
}

export const getUrlMask = (urlSearch = "") => {
	const params = new URLSearchParams(urlSearch)
	let mask = params.get("filter")
	return parseInt(mask, 16) || undefined
}

export const updateUrlFilter = (urlSearch = "", eventCtrlKey, filterBit) => {
	const params = new URLSearchParams(urlSearch)
	const currFilter = params.get("filter")

	/**
	 * @type {number}
	 */
	let filter = parseInt(currFilter, 16) || 0
	if (eventCtrlKey) {
		if ((filter & filterBit) !== 0) {
			filter &= ~filterBit
		} else {
			filter |= filterBit
		}
	} else if ((filter & filterBit) === 0 || (filter & ~filterBit) !== 0) {
		filter = filterBit
	} else {
		filter = 0
	}

	if (filter === 0) {
		params.delete("filter")
	} else {
		params.set("filter", filter.toString(16).toUpperCase().padStart(8, "0"))
	}

	return `?${params.toString()}`
}

const handleFilterChange = (props) => (e, filterBit) => {
	e.persist()
	const { search, pathname } = props.location || {}

	const newSearch = updateUrlFilter(search, e.ctrlKey || e.metaKey, filterBit)

	props.history.push({
		pathname,
		search: newSearch,
	})
}

const getActiveOverlay = (search) => {
	const params = new URLSearchParams(search)
	return params.get("overlay")
}

const getSummaryHeading = (activeOverlay) => {
	switch (activeOverlay) {
		case overlays.ALARMS:
			return ["Master Alarms", "Count"]
		case overlays.FLAGS:
			return ["Master Status Flags ", "Count"]
		default:
			return null
	}
}

const getAlarmsSummary = (state, props, activeMasters, allMasters) => {
	let summaryData = []
	let alarmCounts = {}
	let activeAlarmModes = 0

	for (let x = 0; x < 32; x++) {
		alarmCounts[1 << x] = 0
	}

	const userPrivileges = state.user.privileges
	let deviceType
	const masters = activeMasters.length === 0 ? allMasters : activeMasters

	masters.forEach((mLocId) => {
		deviceType = getDeviceType(state, mLocId)
		const urlSearch = (props.location || {}).search
		const timestamp = getUrlTimestamp(urlSearch) || state.masterDataLatestTimestamp[mLocId]
		const masterData = state.masterData[`${mLocId}#${timestamp}`] || {}
		let { alarms } = masterData
		let masterAlarms = parseInt(alarms, 16)

		if (masterAlarms) {
			for (let x = 0; x < 32; x++) {
				if (((1 << x) & masterAlarms) !== 0) {
					alarmCounts[1 << x]++
				}
			}
		}

		for (let x = 0; x < 32; x++) {
			if (alarmCounts[1 << x]) {
				activeAlarmModes |= 1 << x
			}
		}
	})

	const masterAlarmModesList = getMasterAlarmModesList(userPrivileges, deviceType)
	for (let i = 0; i < masterAlarmModesList.length; i++) {
		if ((activeAlarmModes & masterAlarmModesList[i].bit) !== 0) {
			summaryData.push({
				action: masterAlarmModesList[i].bit,
				description: masterAlarmModesList[i].description,
				value: alarmCounts[masterAlarmModesList[i].bit],
			})
		}
	}

	return {
		summaryData,
	}
}

const getFlagsSummary = (state, props, activeMasters, allMasters) => {
	let summaryData = []

	let flagCounts = {}
	let activeFlagModes = 0
	for (let x = 0; x < 32; x++) {
		flagCounts[1 << x] = 0
	}

	const userPrivileges = state.user.privileges
	let deviceType
	const masters = activeMasters.length === 0 ? allMasters : activeMasters

	masters.forEach((mLocId) => {
		deviceType = getDeviceType(state, mLocId)
		const urlSearch = (props.location || {}).search
		const timestamp = getUrlTimestamp(urlSearch) || state.masterDataLatestTimestamp[mLocId]
		const masterData = state.masterData[`${mLocId}#${timestamp}`] || {}
		let { flags } = masterData
		let masterFlags = parseInt(flags, 16)

		if (masterFlags) {
			for (let x = 0; x < 32; x++) {
				if (((1 << x) & masterFlags) !== 0) {
					flagCounts[1 << x]++
				}
			}
		}

		for (let x = 0; x < 32; x++) {
			if (flagCounts[1 << x]) {
				activeFlagModes |= 1 << x
			}
		}
	})

	const masterFlagModesList = getMasterFlagModesList(userPrivileges, deviceType)
	for (let i = 0; i < masterFlagModesList.length; i++) {
		if ((activeFlagModes & masterFlagModesList[i].bit) !== 0) {
			summaryData.push({
				action: masterFlagModesList[i].bit,
				description: masterFlagModesList[i].description,
				value: flagCounts[masterFlagModesList[i].bit],
			})
		}
	}

	return {
		summaryData,
	}
}

const mapStateToProps = (state, props) => {
	let summaryData = null
	let summaryHeading

	const activeOverlay = getActiveOverlay(props.location.search)
	let activeMasters = getMasterLocIds(props.location.search)
	let allMasters = state.layoutDetails[props.match.params.layoutId]["mLocIds"]

	summaryHeading = getSummaryHeading(activeOverlay)

	switch (activeOverlay) {
		case overlays.ALARMS:
			summaryData = getAlarmsSummary(state, props, activeMasters, allMasters).summaryData
			break
		case overlays.FLAGS:
			summaryData = getFlagsSummary(state, props, activeMasters, allMasters).summaryData
			break
		default:
			break
	}

	return {
		summaryHeading,
		summaryData,
		summaryIsOpen: state.summaryIsOpen,
		visibilityMask: getUrlMask((props.location || {}).search),
	}
}

const mapDispatchToProps = (dispatch, props) => ({
	handleFilterChange: handleFilterChange(props),
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(MastersSummary)
